import "./App.css";
import Navbar from "./Components/Pages/Navbar/Navbar";
import AllRoutes from "./Components/Roouters/AllRoutes";

function App() {
  return (
    <>
      <Navbar />
      <AllRoutes />
    </>
  );
}

export default App;
